
export function parseBoolOrDefault<T>(str: string | null | undefined, def: T): boolean | T {
  if (str === 'true') {
    return true;
  }
  if (str === 'false') {
    return false;
  }
  return def;
}

export function parseBoolOrUndefined(str: string | null | undefined): boolean | undefined {
  return parseBoolOrDefault(str, undefined);
}
